<template>
  <div class="myinformation-section">
    <div class="personal-information-container">
      <div class="personal-content-title">
        <p>个人基本信息</p>
      </div>
      <el-form
        style="font-size: 12px"
        label-width="100px"
        :model="userForm"
        size="small"
        :rules="rules"
        ref="userForm"
        class="person-form"
      >
        <el-form-item prop="image_id" label="头像上传">
          <el-upload
            action=""
            class="avatar-uploader"
            :show-file-list="false"
            :http-request="uploadAvatarImage"
            :before-upload="beforeAvatarUpload"
            v-model="userForm.image_id"
          >
            <img v-if="image_url" :src="image_url" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="agreement_file_id" label="协议上传">
          <el-upload
            action=""
            class="avatar-uploader"
            :show-file-list="false"
            :http-request="uploadAgreement"
            :before-upload="beforeAvatarUpload"
            v-model="userForm.agreement_file_id"
          >
            <img v-if="agreement_url" :src="agreement_url" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="教师姓名" prop="name">
          <el-input
            v-model="userForm.name"
            placeholder="请输入姓名"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select
            v-model="userForm.gender"
            placeholder="请选择性别"
            class="form-input"
          >
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone_number">
          <el-input
            v-model="userForm.phone_number"
            placeholder="请输入联系电话"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="年龄" prop="age">
          <el-input
            type="number"
            v-model="userForm.age"
            placeholder="请输入年龄"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="教龄" prop="educational_years">
          <el-input
            type="number"
            v-model="userForm.educational_years"
            placeholder="请输入教龄"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="identity_card">
          <el-input
            v-model="userForm.identity_card"
            placeholder="请输入身份证号码"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="userForm.address"
            placeholder="请输入详细地址"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在学校" prop="school_id">
          <el-select
            v-model="userForm.school_id"
            filterable
            placeholder="请选择学校"
            class="form-input"
          >
            <el-option
              v-for="item in constData.school"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="校长姓名" prop="headmaster">
          <el-input
            v-model="userForm.headmaster"
            placeholder="请输入姓名"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="校长电话" prop="headmaster_phone">
          <el-input
            v-model="userForm.headmaster_phone"
            placeholder="请输入校长电话"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="所教科目" prop="subject_taught">
          <el-select
            v-model="userForm.subject_taught"
            multiple
            placeholder="请选择"
            class="form-input"
          >
            <el-option
              v-for="item in constData.subject"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地区" prop="district_codes">
          <el-cascader
            :props="{ value: 'value', label: 'label' }"
            :options="constData.district"
            v-model="userForm.district_codes"
            class="form-input"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="自我介绍" prop="content">
          <el-input
            resize="none"
            type="textarea"
            placeholder="请输入内容"
            v-model="userForm.content"
            rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div style="text-align: left">
            <el-button type="primary" @click="handleSubmit" size="mini"
              >保存</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="class-information-container">
      <div class="class-content-title">
        <p>班级基本信息</p>
        <el-button type="primary" size="mini" @click="showInputAdd"
          >添加班级</el-button
        >
      </div>
      <el-alert
        title="点击班级卡片可对相应的班级进行编辑，点击删除图标可对其进行删除～"
        type="warning"
      >
      </el-alert>
      <div class="class-info-list">
        <div
          class="class-info-item"
          v-for="(item, index) in classList"
          :key="item.id"
          @click="getClassShow(item)"
        >
          <div class="close">
            <el-link
              icon="el-icon-delete"
              :underline="false"
              type="danger"
              @click.stop="delClass(item.id, index)"
            ></el-link>
          </div>
          <div class="class-item-grade">年级：{{ item.grade_name }}</div>
          <div class="class-item-class">班级：{{ item.class_name }}</div>
          <div class="class-item-number">人数：{{ item.class_size }}</div>
          <div class="class-item-introduction">介绍：{{ item.content }}</div>
        </div>
      </div>
      <div class="class-form">
        <el-form
          style="font-size: 12px;"
          label-width="80px"
          :model="classData"
          size="small"
          ref="classForm"
          :rules="classRules"
        >
          <el-form-item label="选择年级" prop="grade_id">
            <el-select
              v-model="classData.grade_id"
              placeholder="请选择年级"
              class="form-input"
            >
              <el-option
                v-for="item in constData.grade"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级名称" prop="class_name">
            <el-input
              v-model="classData.class_name"
              placeholder="请输入班级名称"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="班级人数" prop="class_size">
            <el-input
              v-model.number="classData.class_size"
              placeholder="请输入班级人数"
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="班级情况" prop="content">
            <el-input
              resize="none"
              type="textarea"
              placeholder="请输入班级情况介绍"
              v-model="classData.content"
              rows="8"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="class-form-button">
          <el-button @click="eliminateClassData" size="medium">清除</el-button>
          <el-button
            v-show="!showAddEdit"
            type="primary"
            plain
            size="medium"
            @click="addClass"
            >新增班级</el-button
          >
          <el-button
            v-show="showAddEdit"
            type="primary"
            plain
            size="medium"
            @click="editClass"
            >编辑班级</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constService from "@/global/service/const";
import userService from "@/global/service/user";
import ossService from "@/global/service/oss";
import { mapState } from "vuex";
export default {
  data() {
    return {
      classRules: {
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        class_name: [
          { required: true, message: "请填写班级名称", trigger: "blur" }
        ],
        class_size: [
          { required: true, message: "请输入班级人数", trigger: "blur" },
          { type: "number", message: "年龄必须为数字值" }
        ],
        grade_id: [{ required: true, message: "请选择年级", trigger: "change" }]
      },
      classData: {
        class_name: "",
        class_size: null,
        content: "",
        grade_id: null
      },
      image_url: null,
      agreement_url: null,
      showAddEdit: false,
      classList: [],
      rules: {
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        identity_card: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "证件号码格式有误！",
            trigger: "blur"
          }
        ],
        phone_number: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        educational_years: [
          { required: true, message: "请输入教龄", triggle: "blur" }
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        district_codes: {
          required: true,
          message: " 请选择地区",
          trigger: "change"
        },
        agreement_file_id: [
          { required: false, message: "请上传协议图片", trigger: "change" }
        ],
        content: [{ required: true, message: "请输入介绍", trigger: "change" }],
        headmaster: [
          { required: true, message: "请填写校长名称", trigger: "blur" }
        ],
        headmaster_phone: [
          { required: true, message: "请填写校长手机号码", trigger: "blur" }
        ],
        image_id: [
          { required: false, message: "请上传头像", trigger: "change" }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        school_id: [
          { required: true, message: "请选择学校", trigger: "change" }
        ],
        subject_taught: [
          { required: true, message: "请选择教育科目", trigger: "blur" }
        ]
      },
      gradeConst: [
        { id: 1, label: "一" },
        { id: 2, label: "二" },
        { id: 3, label: "三" },
        { id: 4, label: "四" },
        { id: 5, label: "五" },
        { id: 6, label: "六" },
        { id: 7, label: "七" },
        { id: 8, label: "八" }
      ],
      userForm: {},
      constData: {
        district: [],
        school: [],
        grade: [],
        subject: []
      },
      imageType: ["jpg", "jpeg", "png"]
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created() {
    this.getData();
    Promise.all([
      constService.districts(),
      constService.grades(),
      constService.school(),
      constService.subject()
    ]).then(res => {
      this.constData.district = res[0];
      this.constData.school = res[2];
      this.constData.grade = res[1];
      this.constData.subject = res[3];
    });
  },
  methods: {
    getData() {
      userService.classList().then(res => {
        this.classList = res.classrooms.map(data => {
          data.grade_name =
            this.gradeConst.find(item => item.id == data.grade_id).label +
            "年级";
          return data;
        });
      });
      this.userForm = {
        name: this.userInfo.name,
        age: Number(this.userInfo.age),
        gender: this.userInfo.gender,
        phone_number: this.userInfo.phone_number,
        educational_years: this.userInfo.educational_years,
        identity_card: this.userInfo.identity_card,
        headmaster: this.userInfo.headmaster,
        headmaster_phone: this.userInfo.headmaster_phone,
        district_codes: this.userInfo.district_codes,
        address: this.userInfo.address,
        subject_taught: this.userInfo.subject_taught.map(data => {
          return Number(data.id);
        }),
        content: this.userInfo.content,
        school_id: this.userInfo.school.id,
        image_id: (this.userInfo.image || {}).id,
        agreement_file_id: (this.userInfo.agreement_file || {}).id
      };
      this.image_url = (this.userInfo.image || {}).file_src;
      this.agreement_url = (this.userInfo.agreement_file || {}).file_src;
    },
    delClass(id, index) {
      this.$confirm("确认删除该班级？").then(() => {
        userService.classDelete(id).then(() => {
          this.$message.success("删除成功");
          this.classList.splice(index, 1);
        });
      });
    },
    eliminateClassData() {
      this.classData = {
        class_name: "",
        class_size: null,
        content: "",
        grade_id: null
      };
    },
    editClass() {
      this.$refs["classForm"].validate(valid => {
        if (valid) {
          let id = this.classData.id;
          const params = {
            grade_id: this.classData.grade_id,
            class_name: this.classData.class_name,
            class_size: this.classData.class_size,
            content: this.classData.content
          };
          userService.classEdit(id, params).then(() => {
            this.$message.success("编辑成功");
            this.eliminateClassData();
            this.$refs.classForm.resetFields();
            this.getData();
          });
        }
      });
    },
    addClass() {
      this.$refs.classForm.validate(valid => {
        if (valid) {
          const params = {
            grade_id: this.classData.grade_id,
            class_name: this.classData.class_name,
            class_size: this.classData.class_size,
            content: this.classData.content
          };
          userService.classCreate(params).then(() => {
            this.$message.success("添加成功");
            this.eliminateClassData();
            this.$refs.classForm.resetFields();
            this.getData();
          });
        }
      });
    },
    showInputAdd() {
      this.classData = {
        class_name: "",
        class_size: null,
        content: "",
        grade_id: null
      };
      this.showAddEdit = false;
    },
    getClassShow(item) {
      this.classData = item;
      this.showAddEdit = true;
    },
    handleSubmit() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          const params = this.userForm;
          userService.userInfoEdit(params).then(() => {
            this.$message.success("编辑成功");
            window.location.reload();
          });
        }
      });
    },
    beforeAvatarUpload(file) {
      const type = file.name.split(".").pop();
      const imageRegex = new RegExp(`${this.imageType.join("|")}`, "i");
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isJPG = imageRegex.test(type);
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG、PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    uploadAvatarImage(file) {
      this.uploading = true;
      ossService
        .upload({ file }, () => {})
        .then(res => {
          this.image_url = res.path;
          this.userForm.image_id = res.id;
        })
        .finally(() => {
          this.$message.success("上传成功");
          this.uploading = false;
        });
    },
    uploadAgreement(file) {
      this.uploading = true;
      ossService
        .upload({ file }, () => {})
        .then(res => {
          this.agreement_url = res.path;
          this.userForm.agreement_file_id = res.id;
        })
        .finally(() => {
          this.$message.success("上传成功");
          this.uploading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item__label {
  font-size: 12px !important;
}

.myinformation-section {
  background: #ffffff;
  height: 100%;
  font-size: 12px;
  color: #2c3e50;
  .person-form {
    padding: 50px 20px;
  }
  .personal-information-container {
    .personal-content-title {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dedede;
      justify-content: space-between;
      padding: 0 15px;
      height: 40px;
      .el-button {
        font-size: 12px;
        color: #ffffff;
        font-weight: 300;
        width: 56px;
        height: 32px;
        padding: 0;
        background: #ff9900;
      }
    }
  }
  .class-information-container {
    .class-content-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      height: 40px;
      border-bottom: 1px solid #dedede;
    }
    .class-info-list {
      display: flex;
      padding: 20px;
      padding-top: 0;
      flex-wrap: wrap;
      margin-right: 30px;
      .class-info-item {
        position: relative;
        text-align: left;
        margin: 16px;
        background-color: rgb(255, 245, 230);
        border-radius: 10px;
        width: 260px;
        height: 140px;
        display: flex;
        flex-direction: column;
        padding: 12px 24px;
        line-height: 2;
        cursor: pointer;
        .close {
          z-index: 10;
          position: absolute;
          top: 8px;
          right: 8px;
          height: 0;
          width: 24px;
          line-height: 24px;
          text-align: center;
          background-color: #fff;
          border-radius: 50%;
          overflow: hidden;
          .el-link {
            font-size: 14px;
          }
        }
        &:hover {
          color: #fff;
          background-color: #f90;
          .close {
            height: 24px;
            &:hover {
              background-color: #f56c6c;
              .el-link {
                color: #fff;
              }
            }
          }
        }
      }
    }
    .class-form {
      .el-form {
        max-width: 500px;
        margin: 0 auto;
        .el-select {
          display: block;
        }
      }
      .class-form-button {
        padding-bottom: 30px;
      }
    }
  }
}
.avatar-uploader {
  text-align: left;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.form-input {
  width: 270px;
}
/deep/.el-form-item__content {
  text-align: left;
}
</style>
